export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS LB 2025.907a8286.pdf";